import { render } from "./reply.html?vue&type=template&id=12b556ce"
import script from "./Reply.vue?vue&type=script&lang=ts"
export * from "./Reply.vue?vue&type=script&lang=ts"

import "./reply.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script